// ── LT-1 — the "Coming soon" screen ──────────────────────────────────────────
// Six screens were browser-only previews: real-looking pages that saved to one
// browser's localStorage and nowhere else. BrowserOnlyBanner labelled them
// honestly, but a labelled preview is still a page a customer can pour a
// month's real data into and lose. They are now routable, visible and plainly
// not ready.
//
// ⛔ THE OLD COMPONENTS AND THEIR localStorage KEYS ARE NOT DELETED. Anything a
// user already typed stays exactly where it is, in their browser, untouched —
// resurrecting a screen is one line in renderPage(). Hiding is reversible;
// deleting somebody's data is not.
import { C } from "../customers/theme";

const FEATURES = {
  bank: {
    title: "Bank",
    lines: [
      "Import your bank statement as a CSV and see every transaction in one place.",
      "Match incoming payments to the invoices they pay, so what a customer owes is always current without anyone typing it in twice.",
    ],
  },
  payroll: {
    title: "Payroll",
    lines: [
      "Irish PAYE, PRSI and USC worked out per employee, per pay run.",
      "Payslips, and the figures a Revenue payroll submission needs.",
    ],
  },
  staff: {
    title: "Staff & Rota",
    lines: [
      "Your team, their hourly rates, and who is working when.",
      "Hours worked feeding straight into a pay run instead of a separate spreadsheet.",
    ],
  },
  projects: {
    title: "Projects",
    lines: [
      "A job or site with its own budget, and what has actually been spent against it.",
      "Invoices, expenses and purchase orders grouped by the project they belong to, so you can see which jobs make money.",
    ],
  },
  calendar: {
    title: "Calendar",
    lines: [
      "Deliveries, jobs and appointments on one shared calendar.",
      "The dates that already matter — invoice due dates, VAT return deadlines — shown alongside them.",
    ],
  },
  acctasks: {
    title: "Accounting Tasks",
    lines: [
      "A checklist of what is due and when: VAT returns, bank reconciliation, year end.",
      "Shared with your accountant, so both of you can see what is done and what is outstanding.",
    ],
  },
};

export default function ComingSoon({ page, onBack }) {
  const feature = FEATURES[page] || { title: "Coming soon", lines: [] };
  return (
    <div
      role="region"
      aria-label={`${feature.title} — coming soon`}
      style={{ maxWidth: 620, margin: "48px auto", textAlign: "center", padding: "0 16px" }}
    >
      <div style={{ fontSize: 34, marginBottom: 12 }} aria-hidden="true">🚧</div>
      <h2 style={{ margin: "0 0 6px", fontSize: 22, fontWeight: 700, color: C.text }}>{feature.title}</h2>
      <div style={{ fontSize: 13, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", color: C.primary, marginBottom: 18 }}>
        Coming soon
      </div>
      <div style={{ fontSize: 14, color: "#94a3b8", lineHeight: 1.7, marginBottom: 26 }}>
        {feature.lines.map((l, i) => <p key={i} style={{ margin: "0 0 10px" }}>{l}</p>)}
      </div>
      {/* Said plainly, because a customer who used the old preview screen
          deserves to know their data was not thrown away. */}
      <div style={{ fontSize: 12.5, color: "#64748b", lineHeight: 1.6, marginBottom: 26 }}>
        This screen is not ready yet, so it is not switched on. If you entered anything here before,
        it is still saved in this browser and nothing has been deleted.
      </div>
      <button
        onClick={onBack}
        style={{ padding: "9px 18px", background: C.primary, border: "none", borderRadius: 8, color: "#04212b", fontSize: 13, fontWeight: 700, cursor: "pointer" }}
      >
        Back to dashboard
      </button>
    </div>
  );
}

export { FEATURES };
